<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7JkqqM/tc-custom/9781452170466.jpg?1705766049207" alt="This image is the cover for the book Cocktails with a Twist"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cocktails with a Twist
      </h1>
      <p class="bookDescription body article font2">
        <b>More than 100 variations on twenty-one classic cocktail recipes: Martini, Bloody Mary, Gimlet, Manhattan, Margarita, Moscow Mule, Sangria, and other iconic drinks.</b><br/>  <br/><b>A Top Ten Nominee for the 2020 Spirited Awards</b><br/><b>Finalist for the 2020 IACP Award for Best Cookbook, Wine, Beer or Spirits</b><br/>  <br/> For anyone looking to expand their palate and discover a new favorite go-to drink, this inventive cocktail book is just the thing. Each chapter is based on a classic (like the Manhattan), but inside readers will discover numerous riffs (like swapping Irish whiskey for rye to make a Blackthorn, or substituting amaro for vermouth to make a Black Manhattan). More than 100 variations on twenty-one modern classic cocktail recipes are accompanied by helpful tips on keeping a well-stocked bar, garnishing drinks, and throwing a party. With bold coloring and classic recipes and intriguing variants, <i>Cocktails with a Twist</i> is a cocktail book unlike any other. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kara Newman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14b76444